import { hashKey, useQuery } from '@tanstack/react-query';

import { apiClient } from '@utils';
import { showErrorToast } from '@hooks/showErrorToast';

interface FetchGroupsProps {
  filters: any;
}

interface DeclarationGroupsMeta {
  total: number;
}

export const useDeclarationGroupsMeta = ({ filters }: FetchGroupsProps) =>
  useQuery({
    queryKey: ['declaration-groups-meta', hashKey(filters)],
    queryFn: async (): Promise<DeclarationGroupsMeta> => {
      try {
        const actualFilters = { ...filters };

        const result = await apiClient.declarations.retrieveDeclarationGroupsMetadata.query({
          query: { criteria: JSON.stringify({ filters: actualFilters }) },
        });
        if (result.status !== 200) throw result.body;

        return { total: result.body.metadata?.total };
      } catch (error) {
        showErrorToast(error, 'Failed to fetch declaration groups metadata');
      }
    },
    placeholderData: {
      total: 0,
    },
  });
